// extracted by mini-css-extract-plugin
module.exports = {"container":"Canvas_container__G8Drf","title":"Canvas_title__WoX0H"};